import { ScrollSmoother } from "gsap/ScrollSmoother";

export default class Header{
	constructor(element){
		this.element = element;
		this.options = {
			threshold: 0.1,
			colorThreshold: 0.05,
			noHide: false,
			hasSubmenus: false,
		};

		this.scrollPos = 0;
		this.lastScrollPos = 0;
		this.scrollY = 0;
		this.html = document.documentElement;
		this.labels;
		this.submenuContainer;
		this.timeout;

		this.init();
		this.initNavMobile();
	}

	init(){
		this.setOptions();

		window.addEventListener('scroll', this.onScroll.bind(this));
	}

	setOptions(){
		if('threshold' in this.element.dataset){
			this.options.threshold = this.element.dataset.threshold;
		}

		if('autoHide' in this.element.dataset){
			this.options.noHide = true;
		}

		if('submenus' in this.element.dataset){
			this.options.hasSubmenus = true;
			const nav = document.getElementById("nav");
			this.labels = nav.querySelectorAll(".submenu-parent");
			const elements = nav.querySelectorAll(".submenu-children");
			this.submenuContainer = this.element.querySelector(".submenu-container");

			this.labels.forEach((label) => {
				label.addEventListener("mouseover", this.updateSubmenus.bind(this));
				label.addEventListener("mouseout", this.closeContainer.bind(this));
			});
			this.submenuContainer.addEventListener("mouseover", () => clearTimeout(this.timeout));
			this.submenuContainer.addEventListener("mouseout", this.closeContainer.bind(this));

			elements.forEach((el) => {
				this.submenuContainer
					.querySelector(".container-wrapper")
					.appendChild(el.cloneNode(true));
			});
		}
	}

	updateSubmenus(event) {
		clearTimeout(this.timeout);
		this.element.classList.add("submenu-container-visible");
		const labelRect = event.currentTarget.getBoundingClientRect();
		const elementWrapper = this.submenuContainer.querySelector(".container-wrapper");
		const elements = this.submenuContainer.querySelectorAll(".submenu-children");
		var idx;
		for(let i = 0; i < this.labels.length; ++i) {
			elements[i].style.opacity = "0";
			elements[i].style.pointerEvents = "none";
			if(this.labels[i] == event.currentTarget)
				idx = i;
		}
		const itemRect = elements[idx].getBoundingClientRect();
		var widths = [];
		elements[idx].querySelectorAll("a").forEach((el) => {
			const rect = el.getBoundingClientRect();
			widths.push(rect.width);
		});
		elements[idx].style.opacity = "1";
		elements[idx].style.pointerEvents = "unset";

		const containerRect = this.submenuContainer.getBoundingClientRect();
		const containerWidth = Math.max(itemRect.width, labelRect.width);
		elementWrapper.style.width = `${containerWidth}px`;
		const styles = {
			top: `${labelRect.bottom + 20}px`,
			left: `${labelRect.left + (labelRect.width/2) - 20 - (containerWidth/2)}px`,
			height: `${itemRect.height + 40}px`,
			width: `${containerWidth + 40}px`,
			opacity: "1",
		}

		Object.assign(this.submenuContainer.style, styles);
	}
	closeContainer() {
		this.timeout = setTimeout(() => {
			this.element.classList.remove("submenu-container-visible");
			this.submenuContainer.style.opacity = "0";
		}, 250);
	}

	onScroll(){
		this.lastScrollPos = this.scrollPos;
		this.scrollPos = document.scrollingElement.scrollTop;

		this.setHeaderState();
		this.setDirections();
	}

	setHeaderState(){
		if(this.scrollPos > document.scrollingElement.scrollHeight * this.options.threshold && !this.options.noHide){
			this.html.classList.add('header-is-hidden');
		}
		if (this.scrollPos > document.scrollingElement.scrollHeight * this.options.colorThreshold) {
			this.html.classList.add('header-has-background');
		}
		else{
			this.html.classList.remove('header-is-hidden');
			this.html.classList.remove('header-has-background');
		}
	}

	setDirections(){
		if(this.scrollPos >= this.lastScrollPos){
			this.html.classList.add('is-scrolling-down');
			this.html.classList.remove('is-scrolling-up');
		}
		else{
			this.html.classList.add('is-scrolling-up');
			this.html.classList.remove('is-scrolling-down');
		}
	}

	initNavMobile(){
		const toggle = this.element.querySelector('.js-toggle');
		if(toggle)
			toggle.addEventListener('click', this.onToggleNav.bind(this));
	}

	onToggleNav(){
		const isOpen = this.html.classList.toggle('nav-is-active');
		const toggle = this.element.querySelector('.js-toggle p');
		if (toggle) toggle.textContent = isOpen ? 'Fermer' : 'Menu';
		const smoother = ScrollSmoother.get();

		if(smoother){
			smoother.paused(isOpen);
		} else {
			const wrapper = document.querySelector('#smooth-wrapper') || document.body;
			if(isOpen){
				this.scrollY = wrapper.scrollTop || window.scrollY;
				this._lockScroll = () => {
					wrapper.scrollTop = this.scrollY;
					window.scrollTo(0, this.scrollY);
				};
				window.addEventListener('scroll', this._lockScroll, { passive: true });
				wrapper.addEventListener('scroll', this._lockScroll, { passive: true });
			} else {
				window.removeEventListener('scroll', this._lockScroll);
				wrapper.removeEventListener('scroll', this._lockScroll);
			}
		}
	}
}